const close = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M13.4142%2012L19.7782%2018.364L18.364%2019.7782L12%2013.4142L5.63604%2019.7782L4.22183%2018.364L10.5858%2012L4.22183%205.63604L5.63604%204.22183L12%2010.5858L18.364%204.22183L19.7782%205.63604L13.4142%2012Z'/%3e%3c/svg%3e";
export {
  close as default
};
//# sourceMappingURL=close.svg.es.js.map
